import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Collapse,
  Modal,
  OverlayTrigger,
  Table,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import { lblEmail, lblPhoneNumber, txtAction, txtCreatedDate, txtFeedbackList, txtFullName, txtNoRecordsFound, txtRole } from "../../dataBaseFile/label";
import CompanyDetails from "../companies/companyDetails";
import { FaSearch } from "react-icons/fa";
import { LuArrowUpDown } from "react-icons/lu";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { getGuestUserLinkApi } from "../../service/api/user/getGuestUserLink";
import InternationalPhoneFormat from "../../ui/InternationalPhoneFormat";
import deleteGuestUserLinkApi from "../../service/api/user/deleteGuestUserLink";
import CreateUpdateLink from "./createUpdateLink";
const GuestLoginLink = () => {
  const [basicModal, setBasicModal] = useState(false);
  const [initiColor, setInitiColor] = useState(true);
  const [sortingCol, setSortingCol] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [skeltonVal, setSkeltonVal] = useState(false);
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [elements, setElements] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  const [sortByValue, setSortByValue] = useState("DESC");
  const [columnName, setColumnName] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [totalNoRecord, setTotalNoRecord] = useState(100);
  const [flag, setFlag] = useState(false);
  const [dataToModal, setDataToModal] = useState(false);
  const [handleToaster, setHandleToaster] = useState(false);
  const [toasterType, setToasterType] = useState();
  const [resMessage, setResMessage] = useState("");
  const [firstCheck, setFirstCheck] = useState(false);
  const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);
  const [guestLinkData, setGuestLinkData] = useState(0)
  const rows = elements;

  const [filtreBox, setFiltreBox] = useState(false);
  const [filtreValue, SetFiltreValue] = useState(1);

  const { permissionArr } = useSelector((state) => state.user);
  const permissionArray = permissionArr[0] || []

  const [isExpandedCompanyId, setIsExpandedCompanyId] = useState('');


  const [deleteCompanyLoading, setDeleteCompanyLoading] = useState(false);
  function deleteCompany() {
    setDeleteCompanyLoading(true)
    const details = new FormData();
    details.append("guest_user_login_link_id", dataToModal.guest_user_login_link_id_ids);

    dispatch(
      deleteGuestUserLinkApi(
        details,
        (res) => {
          setDeleteCompanyLoading(false)
          setOpenDialog(false);
          setBasicModal(false);

          let indexToDelete = elements.findIndex(item => item.guest_user_login_link_id_ids === dataToModal.guest_user_login_link_id_ids);
          elements.splice(indexToDelete, 1);

          setResMessage(res.data.message);

          setToasterType("success");

          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);


          onLoadData();
        },
        (res) => {
          setDeleteCompanyLoading(false)
          setOpenDialog(false);
          setResMessage(res.data.message);

          setToasterType("error")

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  }

  const getGuestLinkDetails = (res) => {

    // const newElements = [...elements, ...res.data];
    // const uniqueElements = Array.from(
    //   new Set(newElements.map(JSON.stringify))
    // ).map(JSON.parse);


    setElements(res.data);
    setTotalNoRecord(res.total_count);

    if (res.total_count % pageSize === 0) {
      setTotalPage(parseInt(res.total_count / pageSize));
    } else {
      setTotalPage(parseInt(res.total_count / pageSize + 1));
    }

    if (res.total_count === 0) {
      setTimeout(() => {
        setSkeltonVal(true);
      }, "3000");
    } else {
      setSkeltonVal(true);
    }

    // console.log(parseInt(res.total_records / pageSize), 'quoitent')
  };

  function onLoadData() {
    setSkeltonVal(true);
    setCustomeSkeletonLoading(true);
    var data = {
      guest_user_login_link_id: "",
      page_index: page,
      page_size: pageSize,
      sorting_order: sortByValue,
      sorting_column_name: columnName,
      search_area: searchValue
    }
    dispatch(
      getGuestUserLinkApi(data, (res) => {
        // setElements(res.data.data);
        getGuestLinkDetails(res.data);
        setCustomeSkeletonLoading(false);
        // setTotalNoRecord(res.data.total_count);
        // if (res.data.total_count % pageSize === 0) {
        //   setTotalPage(parseInt(res.data.total_count / pageSize));
        // } else {
        //   setTotalPage(parseInt(res.data.total_count / pageSize + 1));
        // }

        if (res.data.data.length === 0) {
          setTimeout(() => {
            setSkeltonVal(true);
          }, "3000");
        } else {
          setSkeltonVal(true);
        }
      }, (err) => {
        setCustomeSkeletonLoading(true);
      })
    );
  }

  const handleClose = () => {
    setGuestLinkModal(false)

    setPage(1);
    const ele = [];
    setElements(ele);

    onLoadData();
  }

  const handleColumnName = (name) => {
    setSortingCol(false);
    setColumnName(name);

    if (sortByValue === "ASC") {
      setSortByValue("DESC");
    }
    if (sortByValue === "DESC") {
      setSortByValue("ASC");
    }
  };

  const handleOrderValue = (order) => {
    setSortByValue(order);
  };

  const handleSearch = (e) => {
    setPage(1);
    const ele = []
    setElements(ele);

    if (searchValue.trim().length >= 2) {
      onChangePage(1)
      setColumnName('')
    }
    setSearchValue(e.target.value);
  };

  const handleChangeRowsPerPage = (e) => {
    // console.log(e)
    setSearchValue("");
    setPage(1);
    setPageSize(e.target.value);
  };

  const onChangePage = (e, p) => {
    // setPage(p);
    setPage(e);
  };



  useEffect(() => {
    onLoadData();
  }, [sortByValue, pageSize, page, columnName, filtreValue]);

  function onLoadSearch() {
    setSkeltonVal(true);
    var data = {
      guest_user_login_link_id: "",
      page_index: page,
      page_size: pageSize,
      sorting_order: sortByValue,
      sorting_column_name: columnName,
      search_area: searchValue
    }


    dispatch(
      getGuestUserLinkApi(data, (res) => {
        getGuestLinkDetails(res.data);
        // setElements(res.data.data);
        // setTotalNoRecord(res.data.total_count);
        // if (res.data.total_count % pageSize === 0) {
        //   setTotalPage(parseInt(res.data.total_count / pageSize));
        // } else {
        //   setTotalPage(parseInt(res.data.total_count / pageSize + 1));
        // }

        if (res.data.data.length === 0) {
          setTimeout(() => {
            setSkeltonVal(true);
          }, "3000");
        } else {
          setSkeltonVal(true);
        }
      })
    );
  }
  useEffect(() => {
    // if (searchValue.trim().length > 2) {

    //   const ele = [];
    //   setPage(1);
    //   setElements(ele);

    //   setFlag(true);
    //   const timeOutId = setTimeout(onLoadSearch, 1000);
    //   return () => clearTimeout(timeOutId);
    // } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
    //   if (flag) {
    //     onLoadData();
    //   }
    // }

    if (searchValue.trim().length > 2) {
      setFlag(true);
      const timeOutId = setTimeout(onLoadSearch, 1000);
      return () => clearTimeout(timeOutId);
    } else if (searchValue.trim().length === 0) {
      if (flag) {
        onLoadSearch();
      }
    }
  }, [searchValue]);

  const percentage = 70;

  const tooltipDelete = (
    <Tooltip id="tooltip">
      <strong>Delete</strong>
    </Tooltip>
  );
  const tooltipView = (
    <Tooltip id="tooltip">
      <strong>View</strong>
    </Tooltip>
  );
  const tooltipEdit = (
    <Tooltip id="tooltip">
      <strong>Edit</strong>
    </Tooltip>
  );
  // Modal triggers for the Feedback details
  const [showFeedbackDetails, setShowFeedbackDetails] = useState(false);


  const [callDetailsObj, setCallDetailsObj] = useState({});
  const [time, setTime] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState(0);
  const [guestLinkModal, setGuestLinkModal] = useState(false)
  const [GuestLinkModalType, setGuestLinkModalType] = useState("")

  const backToAdminDashboard = () => {
    window.history.back()
  }

  function handleOpenFiltreBox() {
    setFiltreBox(!filtreBox);
  }

  function handleSetFiltreValue(v) {
    SetFiltreValue(v);
    const ele = [];
    setPage(1);
    setElements(ele);
    if (v === 1) {
      setSortByValue("DESC");
    } else if (v === 2) {
      setSortByValue("ASC");
    }
  }

  const searchAreaVal = (e) => {
    // setSearchArea(e.target.value)
    // if (searchArea.trim().length >= 2) {
    //     onChangePage(1)
    // }

    setSearchValue(e.target.value)
    if (searchValue.trim().length >= 2) {
      onChangePage(1)
    }
  }

  // Format the unix time in given format
  function formatUnixTimestamp(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);

    const month = date.toLocaleString('default', { month: 'short' });
    const day = date.getDate();
    let hour = date.getHours();
    const minute = date.getMinutes();

    const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
    const amPm = hour < 12 ? 'am' : 'pm';
    const minuteFormatted = minute < 10 ? `0${minute}` : minute;

    return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
  }

  return (
    <div>
      {/* New Admin dashboard for registered companies */}
      <div className="row mx-3 mb-5" style={{}}>
        <div className="col-12 px-0">

          <div className="row mx-0 p-3">
            <div className="col-6 px-0 ps-2 d-flex align-item-center justify-content-start">
              <span className="fs-4 fw-bold text-black">{"Guest user link"}</span>
            </div>

            <div className="col-6 px-0 pe-2 d-flex align-item-center justify-content-end">

              <button
                onClick={(e) => {
                  setGuestLinkModal(true)
                  setGuestLinkModalType("CREATE")
                }}
                className="admin-add-user "
                style={{ width: 'auto' }}
                variant="light btn-rounded">

                <i
                  className="bi bi-plus-circle-fill"
                  style={{ marginRight: "10px" }}></i>
                {`Create Link `}
              </button>

            </div>
          </div>

          <div className='my-3'>
            <PaginationAndSearching
              handleSearch={searchAreaVal}
              // searchValue={searchArea}
              searchValue={searchValue}
              defaultValue={pageSize}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={totalPage}
              onChange={onChangePage}
            />
          </div>

          <Table responsive >

            <thead>
              <tr className='text-black bg-light'>
                <th
                  style={{ fontWeight: '700' }}
                >
                  {`Actions`}
                </th>



                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("company_email_chr") }}
                >
                  {`Email`}
                  <span className="ml-1">
                    {columnName === 'company_email_chr' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>

                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("company_phone_number_int") }}
                >
                  {`Phone`}
                  <span className="ml-1">
                    {columnName === 'company_phone_number_int' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>


                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("created_date_dtm") }}
                >
                  {`Created on`}
                  <span className="ml-1">
                    {columnName === 'created_date_dtm' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>

                <th></th>
              </tr>
            </thead>

            <tbody>
              {customeSkeletonLoading ?
                <SkeletonTableRow cols={7} /> :
                <>
                  {elements?.length > 0 ?
                    <>
                      {elements?.map((element, index) => {
                        return (
                          <>
                            <tr
                              className={`notification-rows font-w700 ${isExpandedCompanyId === element.guest_user_login_link_id_ids ? "bg-primary text-white " : ""}`}
                              key={index}
                              onClick={() => {
                                // onRowClick(element)
                                if (element?.guest_user_login_link_id_ids === isExpandedCompanyId) {
                                  setIsExpandedCompanyId('')
                                } else {
                                  setIsExpandedCompanyId(element.guest_user_login_link_id_ids)
                                }
                              }}
                            >
                              <td className="d-flex align-items-center">
                                <div className="me-1">
                                  <div className="tooltipCustom">
                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                    <span
                                      className="cursor-pointer  rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center "
                                      style={{ height: '35px', width: '35px' }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setGuestLinkModal(true)
                                        setGuestLinkModalType("UPDATE")
                                        setGuestLinkData(element.guest_user_login_link_id_ids)
                                      }}
                                    >
                                      <i className="bi bi-pencil-square"></i>
                                    </span>
                                  </div>
                                </div>

                                <div className="tooltipCustom">
                                  <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Delete"}</span>
                                  <span
                                    className={`cursor-pointer rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center ${element?.guest_user_login_link_id_ids === isExpandedCompanyId ? '' : 'text-danger'} `}
                                    style={{ height: '35px', width: '35px' }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setDataToModal(element);
                                      setBasicModal(true);
                                    }}
                                  >
                                    <i className="bi bi-trash3"></i>
                                  </span>
                                </div>
                              </td>




                              <td>
                                <span className="w-space-no">{element.email_chr ? element.email_chr : "-"}</span>
                              </td>

                              <td>
                                <span>{!element.phone_number_int ? ('-') : <InternationalPhoneFormat countryCode={element.phone_code_id_lng} phoneNumber={`${element.phone_number_int}`} />}</span>

                              </td>

                              <td>
                                {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}

                                <span className="">{`${element?.created_date_dtm ?
                                  new Intl.DateTimeFormat("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: 'numeric',
                                    minute: 'numeric',
                                    hour12: true
                                  }).format(
                                    element?.created_date_dtm * 1000
                                  ) : '-'}`}</span>
                              </td>


                              <td>
                                {/* <OverlayTrigger placement="top" overlay={tooltip}> */}
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (element?.guest_user_login_link_id_ids === isExpandedCompanyId) {
                                      setIsExpandedCompanyId('')
                                    } else {
                                      setIsExpandedCompanyId(element.guest_user_login_link_id_ids)
                                    }
                                  }}
                                  className="d-flex align-items-center justify-content-center bg-light rounded-3 overlay-action-btn text-black"
                                  style={{ fontSize: '15px', height: '30px', width: '35px' }}>
                                  {element?.guest_user_login_link_id_ids === isExpandedCompanyId ? <i class="bi bi-chevron-down"></i> : <i class="bi bi-chevron-right"></i>}
                                </div>
                                {/* </OverlayTrigger> */}
                              </td>
                            </tr>

                            <tr>
                              <td colSpan="8" className={`bg-light ${(element?.guest_user_login_link_id_ids !== isExpandedCompanyId) ? 'p-0' : ''}`}>
                                <Collapse
                                  in={element?.guest_user_login_link_id_ids === isExpandedCompanyId}
                                >
                                  <div className='row mx-0'>
                                    <div className='col-12 px-0'>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Guest user link`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="" >{element.guest_user_link_chr}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Email`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="" >{element.email_chr ? element.email_chr : "-"}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Phone`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>

                                          <span>{!element.phone_number_int ? ('-') : <InternationalPhoneFormat countryCode={element.phone_code_id_lng} phoneNumber={`${element.phone_number_int}`} />}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Created on`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}
                                          {/* <span className="">
                                            {new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "long",
                                              day: "numeric",
                                              hour: "numeric",
                                              minute: "numeric",
                                            }).format(element.created_date_dtm + "000")}
                                          </span> */}

                                          <span className="">{`${element?.created_date_dtm ?
                                            new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: 'numeric',
                                              minute: 'numeric',
                                              hour12: true
                                            }).format(
                                              element?.created_date_dtm * 1000
                                            ) : '-'}`}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Updated on`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}
                                          {/* <span className="">
                                            {new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "long",
                                              day: "numeric",
                                              hour: "numeric",
                                              minute: "numeric",
                                            }).format(element.updated_date_dtm + "000")}
                                          </span> */}

                                          <span className="">{`${element?.updated_date_dtm ?
                                            new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: 'numeric',
                                              minute: 'numeric',
                                              hour12: true
                                            }).format(
                                              element?.updated_date_dtm * 1000
                                            ) : '-'}`}</span>
                                        </div>
                                      </div>



                                    </div>
                                  </div>
                                </Collapse>
                              </td>
                            </tr>
                          </>
                        )
                      })}</> :
                    <tr>
                      <td colSpan="7">No Records Found</td>
                    </tr>
                  }
                </>
              }
            </tbody>
          </Table>




        </div>
      </div>

      <AcceptRejectModal
        text={"Are you sure you want to delete this link?"}
        onClickReject={() => {
          setBasicModal(false);
        }}
        onClickAccept={deleteCompany}
        modalStatus={basicModal}
        loaderActive={deleteCompanyLoading}
        loadingButtonName={"Deleting..."}
      />
      {guestLinkModal && <CreateUpdateLink guestLinkModalStatus={guestLinkModal} handleClose={() => { handleClose() }} modalType={GuestLinkModalType} guestId={guestLinkData} />}

      {handleToaster && <ResponceToaster toasterType={toasterType} message={resMessage} />}
    </div>
  );
};

export default GuestLoginLink;
